import React from 'react';
import TextInput, {
  textInputPropTypes,
  TEXT_INPUT_OPTIONS,
} from '../../common/molecules/TextInput';
import { SEARCH_AREA_INPUT_ID } from '../../constants';
import useSearchAreaInputLogic from './useSearchAreaInputLogic';

const SEARCH_AREA_INPUT_CONSTS = {
  ICON: 'searchArea',
  ID: SEARCH_AREA_INPUT_ID,
  PLACEHOLDER: 'Where',
};

const SEARCH_AREA_INPUT_OPTIONS = {
  SIZES: TEXT_INPUT_OPTIONS.SIZES,
};

const SearchAreaInput = ({ className, size }) => {
  const { handleBlur, handleChange, handleFocus } = useSearchAreaInputLogic();
  return (
    <TextInput
      className={className}
      handleBlur={handleBlur}
      handleChange={handleChange}
      handleFocus={handleFocus}
      icon={SEARCH_AREA_INPUT_CONSTS.ICON}
      id={SEARCH_AREA_INPUT_CONSTS.ID}
      placeholder={SEARCH_AREA_INPUT_CONSTS.PLACEHOLDER}
      size={size}
    />
  );
};

const searchAreaInputPropTypes = {
  className: textInputPropTypes.className,
  size: textInputPropTypes.size,
};
const searchAreaInputDefaultProps = {
  className: undefined,
  size: undefined,
};

export default SearchAreaInput;
export {
  SEARCH_AREA_INPUT_OPTIONS,
  SEARCH_AREA_INPUT_CONSTS,
  searchAreaInputDefaultProps,
  searchAreaInputPropTypes,
};
